import React, { CSSProperties, FC, useCallback, useEffect, useState } from 'react';
import DebouncedAutoComplete from './DebouncedAutoComplete';
import { useFetchCitySuggestions } from '../../hooks/useFetchCitySuggestions';
import { splitPostalCodeAndCity } from '../../utils/formatting';
import { RequiredFormikValues } from './FormikPostalCodeAndCityInput';

export type PostalCodeAndCityInputProps = {
  label: string;
  value?: string;
  countryISO?: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  validationMessage?: string;
  style?: CSSProperties;
};

const PostalCodeAndCityInput: FC<PostalCodeAndCityInputProps> = ({
  label,
  value,
  countryISO,
  onBlur,
  onChange,
  validationMessage,
  style,
}) => {
  const fetchCitySuggestions = useFetchCitySuggestions({ countryISO, limit: 10 });

  return (
    <DebouncedAutoComplete
      label={label}
      value={value}
      dataCy="AddressPostalCodeAndCity"
      onChange={onChange}
      onBlur={onBlur}
      fetchSuggestions={fetchCitySuggestions}
      style={style}
      validationMessage={validationMessage}
    />
  );
};

export default PostalCodeAndCityInput;
